import { render } from "./CadastrarNoticia.vue?vue&type=template&id=1921cb5c&scoped=true"
import script from "./CadastrarNoticia.vue?vue&type=script&lang=js"
export * from "./CadastrarNoticia.vue?vue&type=script&lang=js"

import "./CadastrarNoticia.vue?vue&type=style&index=0&id=1921cb5c&scoped=true&lang=scss"
import "./CadastrarNoticia.vue?vue&type=style&index=1&id=1921cb5c&lang=scss"

import exportComponent from "C:\\Users\\marce\\OneDrive\\Área de Trabalho\\Nova pasta (4)\\NoroesteRural 10.25.13\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1921cb5c"]])

export default __exports__